import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';
import ScheduleStore from './ScheduleStore';

var obx = observable({
  sessions: [],
  multi: false,
  addSession: false,
  reportIncident: false,
  incidentSession: null,
  incidentSid: null,
  // Get session
  getSession: action(function(accessKey, component, dialogContent) {
    // Check if the session is already being viewed
    let session = obx.sessions.filter(function(key){
      return key.accessKey === accessKey;
    })[0];

    if(typeof session === 'undefined') {
      SessionStore.startLoading('Loading…', 'GetManagerSession');

      api.get(`/sessions/${accessKey}`)
        .then(response => {
          obx.sessions.push(response.data);
          SessionStore.finishLoading('GetManagerSession');

          const { installSid, courseSid, enrollmentSid, examSid, sid, schedulingModule } = response.data;

          component.setState({
            installSid,
            courseSid,
            examSid,
            schedulingModule
          })

          obx.getSessionEnrollment(installSid, courseSid, enrollmentSid, sid);
          obx.getSessionExam(installSid, courseSid, examSid, sid);
        })
        .catch(error => {
          SessionStore.throwError(error);
        })
    } else {
      obx.addSession = false;
      SessionStore.showDialog(dialogContent);
    }
  }),
  // Get the session details
  appointmentTimelineSession: null,
  getExamSession: action( function (installSid, examSid, sessionSid, dialogContent, component, appointmentTimeline = false) {
    // Check if the session is already being viewed
    let session = obx.sessions.filter(function(key){
      return key.sid === sessionSid;
    })[0];



    if(typeof session === 'undefined') {
      SessionStore.startLoading('Loading…', 'GetManagerExamSession');

      return api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}`)
        .then(response => {
          obx.sessions.push(response.data);

          // Get enrollment and exam data
          const { courseSid, enrollmentSid, examSid, sid } = response.data;
          obx.getSessionEnrollment(installSid, courseSid, enrollmentSid, sid);
          if(!appointmentTimeline){
            obx.getSessionExam(installSid, courseSid, examSid, sid);
          }

          // Add the courseSid to the parent state so we can use it later
          component.setState({
            courseSid
          });

          // Finish loading
          SessionStore.finishLoading('GetManagerExamSession');

          if(appointmentTimeline){
            return response.data;
          }

        })
        .catch(error => {
          SessionStore.throwError(error);
        })
    } else {
      obx.addSession = false;
      if(!appointmentTimeline) {
        SessionStore.showDialog(dialogContent);
      } else {
        return  session;
      }

    }
  }),
  // Get the session enrollment
  getSessionEnrollment: action(function (installSid, courseSid, enrollmentSid, sessionSid) {
    SessionStore.startLoading('Loading…', 'GetManagerExamEnrollment');

    api.get(`/installs/${installSid}/courses/${courseSid}/enrollments?enrollmentSid=${enrollmentSid}`)
      .then(response => {
        // Filter the response to only the current enrollment
        const enrollment = response.data.results[0];

        // Get this session from the array
        let session = obx.sessions.filter(function(key){
          return key.sid === sessionSid;
        })[0];

        // Add the enrollment data to this session
        session.enrollment = enrollment;

        // Finish loading
        SessionStore.finishLoading('GetManagerExamEnrollment');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get the session exam data
  getSessionExam: action(function (installSid, courseSid, examSid, sessionSid) {
    SessionStore.startLoading('Loading…', 'GetManagerExamData');

    api.get(`/installs/${installSid}/courses/${courseSid}/exams/${examSid}`)
      .then(response => {
        // Get this session from the array
        let session = obx.sessions.filter(function(key){
          return key.sid === sessionSid;
        })[0];

        // Add the exam data to this session
        session.exam = response.data;

        // Finish loading
        SessionStore.finishLoading('GetManagerExamData');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Close a session
  closeExamSession: action(function(sessionSid){
    obx.sessions = obx.sessions.filter(function(key){
      return key.sid !== sessionSid;
    });
  }),
  // Complete a session
  completeExamSession: action(function(installSid, examSid, sessionSid, callback, schedulingModule){
    SessionStore.startLoading('Loading…', 'CloseManagerSession');

    const data = {
      type: 'messaging',
      reason: 'exam-completed'
    }

    if(schedulingModule) {
      console.log(schedulingModule);

      data.type = schedulingModule;
    }

    api.post(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/close`, data)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('CloseManagerSession');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Cancel exam session
  cancelExamSession: action(function(sessionSid, data, callback) {
    SessionStore.startLoading('Loading…', 'cancelExamSession');

    api.delete(`/proctors/${SessionStore.userData.proctorAccountSid}/sessions/${sessionSid}`, {data})
      .then(response => {
        SessionStore.finishLoading('cancelExamSession');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Return written files
  returnFiles: [],
  returnExam: action(function(installSid, examSid, sessionSid, callback){
    SessionStore.startLoading('Loading…', 'returnExam');

    let formData = new FormData();

    for(let i = 0; i < obx.returnFiles.length; i++) {
      formData.append('returnFiles[]', obx.returnFiles[i]);
    }

    api.put(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/returnFile`, formData)
      .then(response => {
        obx.returnFiles = [];

        ScheduleStore.session.returnedFile = {
          createdDate: response.data.dateCreated,
          file: response.data.url
        };

        if(callback) {
          callback();
        }

        SessionStore.finishLoading('returnExam');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/ManagerStore.js